const UPPERCASE_TOKENS = new Set<string>([
  'AS',
  'AB',
  'S.A.',
  'SPA',
  'LTDA.',
  'CO',
  'UAT',
  'CA',
]);

const capitalizeWords = (str: string): string =>
  str.replace(/[^\s\-&]+/g, (word) => {
    if (UPPERCASE_TOKENS.has(word.toUpperCase())) return word.toUpperCase();
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

export default capitalizeWords;
